/**
 * Public URL helper.
 *
 * On native (Capacitor) builds, `window.location.origin` resolves to
 * `capacitor://localhost`, which leaks into shared / copied / QR URLs.
 * Always route external-facing URLs through this helper so they remain
 * production-grade (`https://elefa.tel`).
 */
import { Capacitor } from "@capacitor/core";

const PUBLIC_BASE = "https://elefa.tel";

export function getPublicOrigin(): string {
  if (Capacitor.isNativePlatform()) return PUBLIC_BASE;
  // On web, use the current origin for production hosts and any
  // non-production preview/dev host so deep-links work in dev too.
  try {
    const host = window.location.hostname;
    if (host === "elefa.tel" || host === "www.elefa.tel") {
      return window.location.origin;
    }
    // Any other host (localhost, preview environments, custom dev domains) →
    // use the current origin so navigation stays inside the running instance.
    return window.location.origin;
  } catch {
    /* ignore */
  }
  return PUBLIC_BASE;
}

export function buildPublicUrl(path: string): string {
  const base = getPublicOrigin().replace(/\/$/, "");
  const suffix = path.startsWith("/") ? path : `/${path}`;
  return `${base}${suffix}`;
}
